import $ from "jquery";
import * as Common from "../../../../common/common";

export default function standart() {}

export const fillDetail = () => {};
